import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  AfterViewInit,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appSsnFormatter]',
  standalone: true,
})
export class SsnFormatterDirective implements AfterViewInit {
  private readonly ngControl = inject(NgControl, { optional: true });
  private readonly el = inject(ElementRef<HTMLElement>);
  private inputEl!: HTMLInputElement;

  ngAfterViewInit(): void {
    this.inputEl = this.el.nativeElement.querySelector('input')!;
  }

  @HostListener('input', ['$event.target'])
  onInput(target: EventTarget | null) {
    if (!(target instanceof HTMLInputElement)) {
      return;
    }
    const value = target.value;

    let sanitizedValue = value.replace(/\D/g, '');
    if (sanitizedValue.length > 9) {
      sanitizedValue = sanitizedValue.substring(0, 9);
    }

    let formattedInput = '';
    if (sanitizedValue.length > 5) {
      formattedInput = `${sanitizedValue.substring(0, 3)}-${sanitizedValue.substring(
        3,
        5,
      )}-${sanitizedValue.substring(5, 9)}`;
    } else if (sanitizedValue.length > 3) {
      formattedInput = `${sanitizedValue.substring(0, 3)}-${sanitizedValue.substring(3, 5)}`;
    } else {
      formattedInput = sanitizedValue;
    }

    this.inputEl.value = formattedInput;
    this.ngControl?.control?.setValue(formattedInput, { emitEvent: false });
  }
}
